// utils/timeFormat.js
export const decHoursToHHMM = (val) => {
  if (val === null || val === undefined || val === "") return "";
  const n = Number(val);
  if (Number.isNaN(n)) return "";
  const h = Math.floor(n);
  const m = Math.round((n - h) * 60);
  const pad = (x) => String(x).padStart(2, "0");
  return `${pad(h)}:${pad(m)}`; // e.g., 9.5 -> "09:30"
};
